import { INbnDashboardTile, IOrganismNbnService } from '@belong/types';
import { Entry } from 'contentful';
import { FLink, IEntryLink } from '../elements';
import {
  FMoleculeAlert,
  FMoleculeInformationPanel,
  FMoleculeRichText,
  FMoleculeText,
  FMoleculeTileHeader,
  IEntryMoleculeAlert,
  IEntryMoleculeRichText,
  IEntryMoleculeText,
  IEntryTileHeader
} from '../molecules';
import {
  FMoleculeNbnServiceTileContent,
  IEntryNbnServiceTileContent
} from '../molecules/moleculeNbnServiceTile.factory';
import { parseFlexibleContent } from '../parseFlexibleContent';
import { FOrganismServiceLinks, IEntryOrganismServiceLinks } from './organismServiceLinks.factory';

type DashboardServiceTileTypes =
  | IEntryLink
  | IEntryMoleculeAlert
  | IEntryMoleculeText
  | IEntryMoleculeRichText
  | IEntryOrganismServiceLinks
  | IEntryTileHeader;

interface IEntryNbnServiceTile {
  key?: string;
  serviceTiles: Entry<IEntryNbnServiceTileContent>[];
  dashboardServiceTile: Entry<DashboardServiceTileTypes>[];
}

const contentFactoryMap = new Map([
  ['elementLink', { factory: FLink }],
  ['moleculeAlert', { factory: FMoleculeAlert }],
  ['moleculeInformationPanel', { factory: FMoleculeInformationPanel }],
  ['moleculeNbnServiceTileContent', { factory: FMoleculeNbnServiceTileContent }],
  ['moleculeRichText', { factory: FMoleculeRichText }],
  ['moleculeText', { factory: FMoleculeText }],
  ['moleculeTileHeader', { factory: FMoleculeTileHeader }],
  ['organismServiceLinks', { factory: FOrganismServiceLinks }]
]);

export const FOrganismNbnServiceTile = ({ fields, sys }: Entry<IEntryNbnServiceTile>): IOrganismNbnService => {
  const { key, dashboardServiceTile, serviceTiles } = fields;
  return {
    key,
    contentId: sys.id,
    dashboardServiceTile: parseFlexibleContent(dashboardServiceTile, contentFactoryMap) as INbnDashboardTile,
    serviceTiles: parseFlexibleContent(serviceTiles, contentFactoryMap)
  };
};
